import {
  filter,
  first,
  groupBy,
  intersection,
  isEmpty,
  map,
  values,
} from 'lodash'

import useLoggedInUser from './use-logged-in-user'

const useFilterOnPermission = elements => {
  const loggedInUser = useLoggedInUser()

  const filteredElements = groupBy(
    filter(
      elements,
      ({ permissions }) =>
        !isEmpty(intersection(loggedInUser?.permissions, permissions)),
    ),
    'key',
  )

  return map(values(filteredElements), element => first(element))
}

export default useFilterOnPermission
